/**
 * @generated SignedSource<<dad80dc99f62f94895a58db755f2442e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type StartContentNodeInput = {
  clientMutationId?: string | null;
  contentNodeId: string;
};
export type advanceTreeNavigation_StartContentNodeMutation$variables = {
  input: StartContentNodeInput;
};
export type advanceTreeNavigation_StartContentNodeMutation$data = {
  readonly LearnV2: {
    readonly startContentNode: {
      readonly clientMutationId: string | null;
      readonly contentSubmission: {
        readonly id: string;
      };
    } | null;
  };
};
export type advanceTreeNavigation_StartContentNodeMutation = {
  response: advanceTreeNavigation_StartContentNodeMutation$data;
  variables: advanceTreeNavigation_StartContentNodeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "LearnV2Mutations",
    "kind": "LinkedField",
    "name": "LearnV2",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "StartContentNodePayload",
        "kind": "LinkedField",
        "name": "startContentNode",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "clientMutationId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ContentSubmission",
            "kind": "LinkedField",
            "name": "contentSubmission",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "advanceTreeNavigation_StartContentNodeMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "advanceTreeNavigation_StartContentNodeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c52d2efec84fcee8aab5d987fd74fe5f",
    "id": null,
    "metadata": {},
    "name": "advanceTreeNavigation_StartContentNodeMutation",
    "operationKind": "mutation",
    "text": "mutation advanceTreeNavigation_StartContentNodeMutation(\n  $input: StartContentNodeInput!\n) {\n  LearnV2 {\n    startContentNode(input: $input) {\n      clientMutationId\n      contentSubmission {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "eaaa598f8c39ee07b2b88369afc72864";

export default node;
